module.exports = __webpack_public_path__ + "img/ic_12_distance.f9f4bd9c.svg";